module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc5"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp#tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cpn"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/abt"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ilust",
      "id": "ilust"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/int",
      "id": "int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01",
      "id": "p01"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(": 1499")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01",
      "id": "c01"
    }
  }, [_vm._v("1 A Question of Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02",
      "id": "c02"
    }
  }, [_vm._v("2 Walking the Tightrope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03",
      "id": "c03"
    }
  }, [_vm._v("3 The Life of the University and the University of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02",
      "id": "p02"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": 1509")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04",
      "id": "c04"
    }
  }, [_vm._v("4 A Lawyer’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c05",
      "id": "c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 A Fair Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c06",
      "id": "c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Council and Councillor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c07",
      "id": "c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Obscure Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/p03",
      "id": "p03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(": 1519")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c08",
      "id": "c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Warrior King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c09",
      "id": "c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Friends, Lovers and Creatures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c10",
      "id": "c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Eminence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c11",
      "id": "c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Wisdom and Folly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c12",
      "id": "c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Prince, Priests and Philosophers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c13",
      "id": "c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 In the Thickets of Obscurity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/p04",
      "id": "p04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(": 1529")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c14",
      "id": "c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Wolsey – The Peacock Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c15",
      "id": "c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Out in the Cold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c16",
      "id": "c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 A Man of Property")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c17",
      "id": "c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Storms and Storm Damage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c18",
      "id": "c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Fatal Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c19",
      "id": "c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Hopes and Fears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c20",
      "id": "c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 The Rise of the New Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/p05",
      "id": "p05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")]), _vm._v(": 1539")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c21",
      "id": "c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 New Brooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c22",
      "id": "c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Out of Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c23",
      "id": "c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 End of an Era")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c24",
      "id": "c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 Under New Management")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c25",
      "id": "c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 The End of the Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c26",
      "id": "c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 The Unholy Maid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c27",
      "id": "c27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 "), _c('em', [_vm._v("Moras Contra Mundum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c28",
      "id": "c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 "), _c('em', [_vm._v("Annus Horribilis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c29",
      "id": "c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 New Men, New Ideas, Old Anxieties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/p06",
      "id": "p06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IX:154")]), _vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c30",
      "id": "c30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 The Scaffold at the Centre of the Labyrinth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c31",
      "id": "c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Faith and Faction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c32",
      "id": "c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 A Lion in the Daniels’ Den")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c33",
      "id": "c33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33 Long Live the King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/epi",
      "id": "epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: 1559")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c34",
      "id": "c34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34 "), _c('em', [_vm._v("Requiescant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/enote",
      "id": "enote",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/bib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359733d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 72
// module chunks = 0